var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_119_59",
    "data-name": "Component 119 \\u2013 59",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union_3",
    "data-name": "Union 3",
    transform: "translate(-17943.004 511.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17961.125 -498.6251831054688 L 17948.875 -498.6251831054688 C 17948.66796875 -498.6251831054688 17948.5 -498.7933959960938 17948.5 -499.0001831054688 C 17948.5 -499.2069702148438 17948.66796875 -499.3751831054688 17948.875 -499.3751831054688 L 17961.125 -499.3751831054688 C 17961.33203125 -499.3751831054688 17961.5 -499.2069702148438 17961.5 -499.0001831054688 C 17961.5 -498.7933959960938 17961.33203125 -498.6251831054688 17961.125 -498.6251831054688 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17948.875 -499.8751831054688 L 17961.125 -499.8751831054688 C 17961.607421875 -499.8751831054688 17962 -499.4834289550781 17962 -499.0001831054688 C 17962 -498.5169372558594 17961.607421875 -498.1251831054688 17961.125 -498.1251831054688 L 17948.875 -498.1251831054688 C 17948.392578125 -498.1251831054688 17948 -498.5169372558594 17948 -499.0001831054688 C 17948 -499.4834289550781 17948.392578125 -499.8751831054688 17948.875 -499.8751831054688 Z",
    stroke: "none",
    fill: "#000"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8578",
    "data-name": "Rectangle 8578",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.77a815984fd6864f242cec972d57a70e.svg";
export { ForwardRef as ReactComponent };